import React from 'react'
import classNames from 'classnames'
import css from './Spinner.pcss'

export enum SpinnerSize {
	Small = 16,
	Default = 32,
	Large = 64,
}

interface SpinnerProps {
	size?: number | SpinnerSize
	className?: string
	qa?: string
}

const Spinner: React.FC<SpinnerProps> = ({
	size = SpinnerSize.Small,
	qa,
	className,
}) => (
	<div
		className={classNames(css.spinner, className)}
		style={{ width: size, height: size }}
		data-qa={qa}
	/>
)

export default Spinner
